// extracted by mini-css-extract-plugin
export default {"wrapper":"itemCard_wrapper__G2UeW","label":"itemCard_label__txL8-","text":"itemCard_text__jv7ne"};